import React, { Fragment } from "react";
import Paper from "@material-ui/core/Paper";

import Grid from "@material-ui/core/Grid";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import styled from "styled-components";

const Pointer = styled.div`
  & {
    color: rgb(153, 153, 153);
  }
  &:hover {
    cursor: pointer;
  }
`;
//TODO: figure out why doesn't styled-components work in parent class
class MetricSwitch extends React.Component {
  contract = () => {
    return (
      <Fragment>
        <ExpandLess />
        <span id="showLessButton" className="toggle-button">SHOW LESS</span>
      </Fragment>
    );
  };
  expand = () => {
    return (
      <Fragment>
        <ExpandMore />
        <span id="viewAllButton" className="toggle-button">VIEW ALL</span>
      </Fragment>
    );
  };

  render() {
    const { onChange, isExpanded } = this.props;
    return (
      <React.Fragment>
        <Pointer onClick={onChange}>
          <Grid
            container
            direction="row"
            alignItems="center"
            justify="flex-end"
          >
            {isExpanded ? this.contract() : this.expand()}
          </Grid>
        </Pointer>
      </React.Fragment>
    );
  }
}

export default MetricSwitch;
